"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadcrumbsContext = exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _helpers = require("../utils/helpers");

var _BreadcrumbsStyled = require("./Breadcrumbs-styled");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BreadcrumbsContext = (0, _react.createContext)({
  breadcrumbsContext: {
    white: undefined,
    dividerCharacter: undefined
  }
});
exports.BreadcrumbsContext = BreadcrumbsContext;
BreadcrumbsContext.displayName = 'BreadcrumbsContext';

var Breadcrumbs = function Breadcrumbs(_ref) {
  var children = _ref.children,
      white = _ref.white,
      dividerCharacter = _ref.dividerCharacter,
      other = _objectWithoutProperties(_ref, ["children", "white", "dividerCharacter"]);

  var breadcrumbsContext = (0, _helpers.useContextState)({
    white: white,
    dividerCharacter: dividerCharacter
  });
  return _react.default.createElement(BreadcrumbsContext.Provider, {
    value: breadcrumbsContext
  }, _react.default.createElement(_BreadcrumbsStyled.StyledBreadcrumbs, other, children));
};

exports.default = Breadcrumbs;
Breadcrumbs.propTypes = {
  /** Crumb components to be rendered within Breadcrumbs. */
  children: _propTypes.default.node,

  /** Color modifier for the Breadcrumbs. */
  white: _propTypes.default.bool,

  /** The character used as a divider between Crumbs */
  dividerCharacter: _propTypes.default.node
};
Breadcrumbs.defaultProps = {
  dividerCharacter: '/'
};
Breadcrumbs.displayName = 'Breadcrumbs';